var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_8_",
    "data-name": "add (8)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.799,
    height: 17.799,
    viewBox: "0 0 17.799 17.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    "data-name": "Group 2583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M8.9,0a8.9,8.9,0,1,0,8.9,8.9A8.909,8.909,0,0,0,8.9,0Zm0,16.421A7.521,7.521,0,1,1,16.421,8.9,7.53,7.53,0,0,1,8.9,16.421Z",
    fill: "#116bef"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585",
    transform: "translate(4.763 4.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2584",
    "data-name": "Group 2584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M144.6,138.685h-2.757v-2.757a.689.689,0,1,0-1.379,0v2.757h-2.757a.689.689,0,0,0,0,1.379h2.757v2.757a.689.689,0,1,0,1.379,0v-2.757H144.6a.689.689,0,1,0,0-1.379Z",
    transform: "translate(-137.022 -135.238)",
    fill: "#116bef"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.81e41a9c7c276108a286d0f65d9e8916.svg";
export { ForwardRef as ReactComponent };